<mat-toolbar color="primary" class="mb-4 nav-menu">
  <mat-toolbar-row>
    <span class="me-3">Axing</span>
    @if (isAdmin) {
      <ul class="nav me-auto">
        <li class="nav-item"><a class="nav-link" routerLinkActive="active" [routerLink]=" ['./'] " [routerLinkActiveOptions]= "{exact: true}" ><span translate>HOMEPAGE</span></a></li>
        <li class="nav-item"><a class="nav-link cursor-pointer" [matMenuTriggerFor]="menu" routerLinkActive="active" (click)="$event.preventDefault()" ><span translate>BASICDATA</span></a></li>
        <li class="nav-item"><a class="nav-link" routerLinkActive="active" routerLink="networks" ><span translate>NETWORKS</span></a></li>
        <li class="nav-item"><a class="nav-link" routerLinkActive="active" routerLink="device" ><span translate>DEVICES</span></a></li>
        <li class="nav-item"><a class="nav-link" routerLinkActive="active" routerLink="attributelookup" ><span translate>ATTRIBUTELOOKUP</span></a></li>
        <li class="nav-item"><a class="nav-link" routerLinkActive="active" routerLink="uploader" ><span translate>UPLOADER</span></a></li>
        <li class="nav-item"><a class="nav-link cursor-pointer" [matMenuTriggerFor]="sync" routerLinkActive="active" (click)="$event.preventDefault()" ><span translate>SYNC</span></a></li>
      </ul>
    }
    <mat-menu #menu="matMenu">
      <button mat-menu-item routerLinkActive="active" routerLink="data/user"><span translate>USERS</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/company"><span translate>COMPANIES</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/site"><span translate>SITES</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/measure">
        <span translate>MEASURE</span> (<span translate>PHYSICALATTRIBUTES</span>)
      </button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/unit"><span translate>UNITS</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/device-type"><span translate>DEVICE_TYPES</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/device-attribute"><span translate>DEVICE_ATTRIBUTES</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/yml"><span translate>YMLEDITOR</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/logs"><span translate>LOGS</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="data/modbusrtu"><span translate>MODBUSRTU</span></button>
    </mat-menu>
    <mat-menu #sync="matMenu">
      <button mat-menu-item routerLinkActive="active" routerLink="sync"><span translate>SYNC_DEFAULTS</span></button>
      <button mat-menu-item routerLinkActive="active" routerLink="sync15min"><span translate>SYNC_15MIN</span></button>
    </mat-menu>
    <button mat-flat-button matTooltip="{{'LOG_OUT' | translate}}" (click)="onLogoutClick()" >
      <mat-icon class="example-icon" aria-hidden="false" >exit_to_app</mat-icon>
      @if (user) {
        <span class="ps-2">{{user.name}}</span>
      }
    </button>
  </mat-toolbar-row>
</mat-toolbar>
